// types/tracking-params.ts
export const TRACKING_PARAMS = [
  '_dssagcrid',
  '_dssftfiid',
  'ads_rl',
  'dclid',
  'ds_a_caid',
  'ds_agid',
  'ds_dest_url',
  'ds_e_adid',
  'ds_e_device',
  'ds_e_matchtype',
  'ds_e_network',
  'ds_s_kwgid',
  'ds_url_v',
  'dsaccountid',
  'dsaccounttype',
  'dscampaign',
  'dscampaignid',
  'dscarmkt',
  'dssagcrid',
  'dssftfiid',
  'fbclid',
  'gad_campaignid',
  'gad_source',
  'gbraid',
  'gclid',
  'gclsrc',
  'gcsrc',
  'gha2spon',
  'lid',
  'mc_cid',
  'mc_eid',
  'msclkid',
  'redirect',
  'sa',
  'ttclid',
  'ttq',
  'utm_campaign',
  'utm_campaignid',
  'utm_content',
  'utm_medium',
  'utm_source',
  'utm_source_platform',
  'utm_term',
  'ved',
] as const

export type TrackingParam = (typeof TRACKING_PARAMS)[number]
